var render, staticRenderFns
import script from "./scan_list.vue?vue&type=script&lang=js"
export * from "./scan_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f456adf4')) {
      api.createRecord('f456adf4', component.options)
    } else {
      api.reload('f456adf4', component.options)
    }
    
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_group/form/scan_list.vue"
export default component.exports